import { accessService } from '@shared/api';

import type { ApiRequest, AuthResponse } from '@shared/types';

export type ExchangeSsoCodeRequest = ApiRequest<{
  code: string;
  codeVerifier: string;
}>;

export const exchangeSsoCode = ({ body, config }: ExchangeSsoCodeRequest) =>
  accessService
    .post<AuthResponse>('/auth/sso/exchange', body, config)
    .then((response) => response.data);
